import { track_with_groups } from "mixpanel-browser";
import { Controller } from "stimulus";
import { getMetaValue } from "../utils/helpers";

export default class extends Controller {
  static targets = [
    "addon",
    "addonModal",
    "featuresModal",
    "chosenPlanName",
    "payPeriod",
    "planTwoPeriod",
    "planThreePeriod",
    "addonPeriod",
    "addonPeriodModal",
    "addonSetting",
    "planContainer",
    "btnContinueWithAddon",
    "btnChangePlan",
    "addCustomerGiving",
    "planContainer",
    "cards",
    "confirmTermsModal",
    "confirmPlanName",
    "confirmPlanPrice",
    "confirmTermsBtn",
  ];

  connect() {
    // this.setPayPeriod();
    // this.checkAddonAndPayPeriod();
  }

  featuresCheck() {
    return fetch("/subscription/features_check", {
      method: "POST",
      body: JSON.stringify({
        chosen_plan_id: this.pricingPlan,
        addon_plan_id: this.addon,
      }),
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": getMetaValue("csrf-token"),
      },
      credentials: "same-origin",
    })
      .then((response) => response.json())
      .then((json) => {
        // set chonsenPlan name
        const chosenPlanName = json.plan_name;
        const chosenPlanLevel = json.plan_level;
        this.chosenPlanNameTarget.textContent = chosenPlanName;
        let objectLength = Object.keys(json.features_missing).length;
        // Remove all recently added children to prevent duplications
        while (this.featuresModalTarget.firstChild) {
          this.featuresModalTarget.removeChild(
            this.featuresModalTarget.firstChild,
          );
        }

        // Set display of customer giving add on
        if (!this.addonTarget.checked && chosenPlanLevel === 1) {
          this.addCustomerGivingTarget.classList.remove("d-none");
        } else {
          this.addCustomerGivingTarget.classList.add("d-none");
          // The offer is hidden, so a toggle left on from an earlier plan must not
          // send Customer Giving along with this one.
          this.addonModalTarget.checked = false;
          this.modalAddonToggled();
        }
        
        if (objectLength > 0) {
          // Iterate throught the features missing values and list them in the modal body
          for (var key in json.features_missing) {
            let element = `<li style="display: flex; align-items: center;"><span class="fa fa-times-circle" style="color: red; margin-right: 8px;font-size: 26px;"></span><p style="color: black; font-size: 18px; margin: 0;">${json.features_missing[key]}</p></li>`;
            let child = document.createElement("li");
            child.innerHTML = element;
            child = child.firstChild;
            this.featuresModalTarget.appendChild(child);
          }
          this.modalController(this.element).showManual(0);
          return true;
        } else {
          return false;
        }
      });
  }

  selectPlan(e) {

    // New stores that have not yet consented confirm their plan (and agree to the
    // Terms) in a modal at the point of selection. Stash the full selection state
    // now so it survives the modal, then resume via confirmTermsAndSelect().
    if (!this.termsAccepted()) {
      e.preventDefault();
      this.pricingPlan = e.currentTarget.dataset["pricingPlan"];
      this.processAddon(e);
      this.qty = e.currentTarget.dataset["quantity"];
      this.activate = e.currentTarget.dataset["activate"];
      this.pendingButton = e.currentTarget;
      this.openTermsConfirm(e.currentTarget);
      return;
    }

    // Change button content to spinner while processing
    const button = e.currentTarget;
    const originalContent = button.innerHTML;
    button.disabled = true;
    button.innerHTML = '<i class="fa fa-circle-o-notch fa-spin"></i>';

    this.pricingPlan = e.currentTarget.dataset["pricingPlan"];

    this.processAddon(e);

    this.qty = e.currentTarget.dataset["quantity"];
    this.activate = e.currentTarget.dataset["activate"];
    this.featuresCheck().then((result) => {
      if (result == true) return;
      this.doPlanSelection(e);
    });

    e.returnValue = false;
  }
  
  // The add on toggle on the same plan card as the clicked button. Every plan has a
  // different add on, so a plan's button must never read another card's toggle.
  addonToggleFor(button) {
    const card = button.closest(".select_plan__card");
    if (!card) return null;
    return this.addonTargets.find((toggle) => card.contains(toggle)) || null;
  }

  processAddon(e) {
    // Start clean so an add on picked for a previously clicked plan can't carry over.
    this.addon = null;

    let shouldProcessAddon = e.currentTarget.dataset["allowAddon"] || false;
    if (!shouldProcessAddon) return;

    const addonToggle = this.addonToggleFor(e.currentTarget);
    const addonChosen = addonToggle && addonToggle.checked;

    if (addonChosen) this.addon = addonToggle.dataset["pricingPlan"];

    if (e.currentTarget.dataset["addonPricingPlan"])
      this.addon = e.currentTarget.dataset["addonPricingPlan"];

    if (!this.payPeriodTarget?.checked) return;

    if (e.currentTarget.dataset["annualPricingPlan"])
      this.pricingPlan = e.currentTarget.dataset["annualPricingPlan"];

    this.addon = addonChosen ? addonToggle.dataset["annualPricingPlan"] : null;

    if (e.currentTarget.dataset["annualAddonPricingPlan"])
      this.addon = e.currentTarget.dataset["annualAddonPricingPlan"];
  }

  // ---- Terms & Conditions consent helpers ----
  termsConsentCheckbox() {
    return document.querySelector('input[name="terms_accepted"]');
  }

  // Satisfied when there is no consent box (existing store) or it is checked.
  termsAccepted() {
    const cb = this.termsConsentCheckbox();
    return !cb || cb.checked;
  }

  showTermsError() {
    const err = document.getElementById("terms-consent-error");
    if (err) err.classList.remove("d-none");
  }

  termsParam() {
    const cb = this.termsConsentCheckbox();
    return cb && cb.checked ? "&terms_accepted=1" : "";
  }

  // Open the "Confirm your plan" modal, populating it from the clicked card and
  // syncing the confirm button to the checkbox's current state (it may already be
  // ticked if the store opened, cancelled and re-opened the modal).
  openTermsConfirm(button) {
    const card = button.closest(".select_plan__card");
    if (card) {
      const name = card.querySelector(".select_plan__card_plan_name h1");
      const price = card.querySelector(".font-blue-highlight");
      if (name) this.confirmPlanNameTarget.textContent = name.textContent.trim();
      if (price) this.confirmPlanPriceTarget.textContent = price.textContent.trim();
    }
    // Restore the button label (a prior attempt may have left a spinner).
    if (this.confirmTermsLabel === undefined)
      this.confirmTermsLabel = this.confirmTermsBtnTarget.innerHTML;
    this.confirmTermsBtnTarget.innerHTML = this.confirmTermsLabel;
    const cb = this.termsConsentCheckbox();
    this.setConfirmTermsBtnDisabled(!(cb && cb.checked));
    const $modal = $(this.confirmTermsModalTarget);
    $modal.one("shown.bs.modal", () => cb && cb.focus());
    $modal.modal("show");
  }

  // Enable/disable the modal's confirm button as the consent box is toggled.
  toggleTermsConfirm(e) {
    const checked = e.currentTarget.checked;
    this.setConfirmTermsBtnDisabled(!checked);
    if (checked) {
      const err = document.getElementById("terms-consent-error");
      if (err) err.classList.add("d-none");
    }
  }

  setConfirmTermsBtnDisabled(disabled) {
    this.confirmTermsBtnTarget.disabled = disabled;
    this.confirmTermsBtnTarget.setAttribute("aria-disabled", disabled ? "true" : "false");
  }

  // Consent given in the modal: resume the exact selection the plan CTA would have
  // run. termsParam() now returns &terms_accepted=1, so the fetch carries consent and
  // the server records it. Mirrors the tail of selectPlan (featuresCheck detour + both
  // payment paths) using the state stashed before the modal opened.
  confirmTermsAndSelect(e) {
    e.preventDefault();
    if (!this.termsAccepted()) {
      this.showTermsError();
      return;
    }
    $(this.confirmTermsModalTarget).modal("hide");
    this.confirmTermsBtnTarget.disabled = true;
    this.confirmTermsBtnTarget.innerHTML = '<i class="fa fa-circle-o-notch fa-spin"></i>';
    this.featuresCheck().then((result) => {
      if (result == true) return;
      this.doPlanSelection({ currentTarget: this.pendingButton });
    });
  }

  selectShopifyPlan(e, pricingPlan, quantity, activate, addonPlan = null) {
    let selectPlanUrl = `/shopify/subscription?price_id=${pricingPlan}`;
    if (quantity) selectPlanUrl += `&quantity=${quantity}`;
    if (activate) selectPlanUrl += `&activate=${activate}`;
    if (addonPlan) selectPlanUrl += `&addon_price_id=${addonPlan}`;
    selectPlanUrl += this.termsParam();
    let btnPlan = e.currentTarget;
    //Show loading
    fetch(selectPlanUrl, {
      method: "POST",
      body: JSON.stringify({
        price_id: pricingPlan,
        quantity: quantity,
        activate: activate,
        addon_price_id: addonPlan
      }),
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": getMetaValue("csrf-token"),
      },
      credentials: "same-origin",
    })
      .then((response) => response.json())
      .then((json) => {
        // Redirect after response
        if (json.confirmationUrl) {
          window.location.href = json.confirmationUrl;
        } else {
          this.loadController(btnPlan).stopProcessing();
          //Display an error
          this.displayError();
        }
      })
      .catch((error) => {
        this.loadController(btnPlan).stopProcessing();
        this.displayError();
      });
  }

  displayError() {
    //Stop loading
    let existingAlert = document.querySelector(".text-center.mt-4 .alert");
    if (existingAlert) existingAlert.remove();
    let alert = document.createElement("div");
    alert.setAttribute("class", "alert alert-danger");
    alert.innerHTML =
      "Oops! It looks like there was an error subscribing to your plan. Please try again or contact support if you still have issues.";
    document.querySelector(".text-center.mt-4").prepend(alert);
  }

  modalAddonToggled(e) {
    if (this.addonModalTarget.checked) {
      this.btnChangePlanTarget.classList.add("d-none");
      this.btnContinueWithAddonTarget.classList.remove("d-none");
    } else {
      this.btnChangePlanTarget.classList.remove("d-none");
      this.btnContinueWithAddonTarget.classList.add("d-none");
    }
  }

  continueWithAddon(e) {
    e.preventDefault();
    console.log(this.addonModalTarget.dataset["pricingPlan"]);
    this.addon = this.addonModalTarget.checked
      ? this.addonModalTarget.dataset["pricingPlan"]
      : null;
    if (this.payPeriodTarget.checked) {
      this.addon = this.addonModalTarget.checked
        ? this.addonModalTarget.dataset["annualPricingPlan"]
        : null;
    }
    this.continueWithPlanSelection(e);
  }

  doPlanSelection(e) {
    if (this.element.dataset.paymentType == "shopify") {
      this.selectShopifyPlan(e, this.pricingPlan,
        this.qty,
        this.activate,
        this.addon);
    } else {
      this.selectStripePlan(
        this.pricingPlan,
        this.qty,
        this.activate,
        this.addon,
      );
    }
  }
  continueWithPlanSelection(e) {
    e.preventDefault();
    if (this.element.dataset["mode"] == "new") {
      this.doPlanSelection(e);
    } else if (this.element.dataset["mode"] == "change") {
      this.doChangePlan(
        this.pricingPlan,
        this.qty,
        this.activate,
        this.addon,
      );
    }
  }

  unsupportedAddon(e) {
    e.preventDefault();
    alert("You cannot select this addon with your current plan.");
  }

  chooseAddon(e) {
    if (
      confirm(
        e.currentTarget.checked
          ? "Proceed with adding customer add on?"
          : "Proceed with removing the customer add on?",
      )
    ) {
      this.addon = this.payPeriodTarget.checked
        ? this.addonTarget.dataset["annualPricingPlan"]
        : this.addonTarget.dataset["pricingPlan"];
      let addOnPlan =
        e.currentTarget.dataset["annualPricingPlan"] ||
        e.currentTarget.dataset["pricingPlan"];
      window.location.href = `${this.element.dataset["addonPath"]}?addon_price_id=${addOnPlan}`;
    } else {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  selectStripePlan(pricingPlan, quantity, activate, addonPlan = null) {
    let selectPlanUrl = `/stripe/subscription/new?price_id=${pricingPlan}`;
    if (quantity) selectPlanUrl += `&quantity=${quantity}`;
    if (activate) selectPlanUrl += `&activate=${activate}`;
    if (addonPlan) selectPlanUrl += `&addon_price_id=${addonPlan}`;
    selectPlanUrl += this.termsParam();
    fetch(selectPlanUrl)
      .then((response) => response.json())
      .then((json) => {
        if (json.session) {
          Stripe(this.data.get("apiKey"))
            .redirectToCheckout({
              sessionId: json.session.id,
            })
            .then((result) => {
              console.log("Checkout response");
              console.log(result);
            });
        } else {
          window.location.href = json.redirect;
        }
      });
  }

  changePlan(e) {
    const addonToggle = e.currentTarget.dataset["allowAddon"]
      ? this.addonToggleFor(e.currentTarget)
      : null;
    const addonChosen = addonToggle && addonToggle.checked;

    this.addon = addonChosen ? addonToggle.dataset["pricingPlan"] : null;
    if (e.currentTarget.dataset["addonPricingPlan"])
      this.addon = e.currentTarget.dataset["addonPricingPlan"];
    this.pricingPlan = e.currentTarget.dataset["pricingPlan"];
    if (this.payPeriodTarget.checked) {
      // Check to make sure user hasn't selected plan 1.
      if (e.currentTarget.dataset["annualPricingPlan"])
        this.pricingPlan = e.currentTarget.dataset["annualPricingPlan"];

      this.addon = addonChosen ? addonToggle.dataset["annualPricingPlan"] : null;
      if (e.currentTarget.dataset["annualAddonPricingPlan"])
        this.addon = e.currentTarget.dataset["annualAddonPricingPlan"];
    }

    this.qty = e.currentTarget.dataset["quantity"];
    this.activate = e.currentTarget.dataset["activate"];
    // Features check
    this.featuresCheck().then((result) => {
      if (!result) {

        this.doChangePlan(
          this.pricingPlan,
          this.qty,
          this.activate,
          this.addon,
        );
      }
    });
  }

  loadController(el) {
    return this.application.getControllerForElementAndIdentifier(el, "load");
  }

  doChangePlan(pricingPlan, quantity, activate, addonPlan = null) {
    let path = `/${this.element.dataset.paymentType}/subscription/change?price_id=${pricingPlan}`;
    if (addonPlan !== null) path = `${path}&addon_price_id=${addonPlan}`;
    window.location.replace(location.protocol + "//" + location.host + path);
  }

  setPayPeriod() {
    this.payPeriodCheck();
    if (this.cardsTarget.dataset["change"] == "true") {
      let selectedPlan = this.planContainerTargets.find(
        (plan) => plan.dataset["selectedPlan"] == "true",
      );
      selectedPlan.querySelector(".plan-header").textContent =
        "Your current plan";
    }
  }

  togglePayPeriod() {
    this.payPeriodCheck();
    if (this.cardsTarget.dataset["change"] == "true") {
      let selectedPlan = this.planContainerTargets.find(
        (plan) => plan.dataset["selectedPlan"] == "true",
      );
      if (!selectedPlan.dataset["plan-1"]) {
        let header = selectedPlan.querySelector(".plan-header");
        let background = selectedPlan.querySelector(".plan-background");
        let buttonContainer = selectedPlan.querySelector(".button-container");
        let buttonContainerSeleceted = selectedPlan.querySelector(
          ".button-container-selected",
        );
        let ribbon = selectedPlan.querySelector(".ribbon");

        header.textContent =
          header.textContent === "Your current plan"
            ? "First 10 orders with giving FREE"
            : "Your current plan";
        background.classList.toggle("rounded-top");
        background.classList.toggle("selected-plan-background-color");
        selectedPlan.classList.toggle("selected-plan-border");
        buttonContainer.classList.toggle("display-none");
        buttonContainerSeleceted.classList.toggle("display-none");
        ribbon && ribbon.classList.toggle("display-none");
      }
    }
  }

  payPeriodCheck() {
    if (this.payPeriodTarget.checked) {
      let planTwoPrice = this.planTwoPeriodTarget.dataset["anPrice"];
      this.planTwoPeriodTarget.textContent = `${planTwoPrice} p/m (paid annually)`;

      let planThreePrice = this.planThreePeriodTarget.dataset["anPrice"];
      this.planThreePeriodTarget.textContent = `${planThreePrice} p/m (paid annually)`;
    } else {
      let addOnPrice = this.addonPeriodTarget.dataset["price"];
      this.addonPeriodModalTarget.textContent = `Add Customer Giving as an add on for ${addOnPrice} p/m`;
      this.addonPeriodTarget.textContent = `Add Customer Giving as an add on for ${addOnPrice} p/m`;

      let planTwoPrice = this.planTwoPeriodTarget.dataset["price"];
      this.planTwoPeriodTarget.textContent = `${planTwoPrice}/month`;

      let planThreePrice = this.planThreePeriodTarget.dataset["price"];
      this.planThreePeriodTarget.textContent = `${planThreePrice}/month`;
    }
  }

  checkAddonAndPayPeriod() {
    if (this.addonTarget.dataset["addonSubscribed"] === "true") {
      this.addonTarget.checked = true;
    }
    if (this.payPeriodTarget.dataset["payQuarterly"] === "true") {
      this.payPeriodTarget.checked = true;
    }
  }

  loadController(el) {
    return this.application.getControllerForElementAndIdentifier(el, "load");
  }
  modalController(el) {
    return this.application.getControllerForElementAndIdentifier(el, "modal");
  }
}
